import Homepage from '../pages/HomePage/HomePage';
import Header from '../components/Header/Header'

function App() {
  return (
    <>
      <Header/>
      <Homepage/>
    </>
  );
}

export default App;
